module.exports = function htmlToPlaintext(text) {
    if (typeof text !== 'string') return '';
    return text.replace(/(<br[^>]*\/?>)+/ig, ' ')
        .replace(/(<p[^>]*\/?>)+/ig, ' ')
        .replace(/<\/?[^>]+(>|$)/g, '')
        .replace(/[\n\r\s\t]+/g, ' ')
        ;
};
